import { render } from "./GoalsView.vue?vue&type=template&id=16b17fd6&scoped=true"
import script from "./GoalsView.vue?vue&type=script&lang=js"
export * from "./GoalsView.vue?vue&type=script&lang=js"

import "./GoalsView.vue?vue&type=style&index=0&id=16b17fd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b17fd6"]])

export default __exports__